<template>
    <div>
        <div
            v-if="view"
            @click="activateItem"
            @dblclick="makeFolder"
            style="cursor:pointer;clear:both"
        >
            <div v-if="isFolder">
                <!--span v-if="isFolder">[{{ isOpen ? '-' : '+' }}]</span-->
                <v-icon v-if="isFolder && !isLoading" @click="toggle" small class="float-left pa-1">
                    {{ isOpen ? "mdi-minus" : "mdi-plus" }}
                </v-icon>
                <v-progress-circular
                    v-if="isFolder && isLoading" class="ma-2 float-left"
                    :size="10" :width="2" indeterminate color="primary"
                ></v-progress-circular>

                <!--v-checkbox
                    v-if="item.is_seq"
                    v-model="item.selected_sequences"
                    :value="item.path"
                    dense
                    color="blue"
                    style="width:24px;float:left;"
                    class="ma-0 pa-0"
                    hide-details
                    v-on:click.stop=""
                    @change="selectDeselectSeqs"
                ></v-checkbox-->

                <template v-if="isFolder">
                    <v-icon v-if="isSequence" small>
                        {{ isOpen ? 'mdi-image-multiple-outline' : 'mdi-image-multiple' }}
                    </v-icon>
                    <v-icon v-else small>
                        {{ isOpen ? 'mdi-folder-open' : 'mdi-folder' }}
                    </v-icon>
                </template>
                <template v-else>
                    <v-icon small>
                        mdi-panorama
                    </v-icon>
                </template>

                <!--v-icon v-if="isFolder" small>
                    {{ isOpen ? 'mdi-folder-open' : 'mdi-folder' }}
                </v-icon>
                <v-icon v-else small>
                    mdi-panorama
                </v-icon-->
                <span class="mx-1">{{item.Name}}</span>
                <span v-if="!isFolder" class="caption grey--text">({{humanFileSize(item.size)}}) - {{(item.time)}}</span>
                <!--v-chip v-if="isDeleting" x-small color="red" class="ml-1">deleting</v-chip-->
                <v-btn v-if="isFolder && isLoaded" plain x-small color="primary" @click="reloadFolder">
                    <v-icon small>mdi-reload</v-icon>
                </v-btn>
                <!--v-btn
                    v-if="isSequence && simPreviewEnabled" plain x-small color="primary"
                    v-on:click.stop="previewItem" title="preview"
                    class="pa-0 ma-0"
                >
                    <v-icon small>mdi-movie-play-outline</v-icon>
                </v-btn>
                <v-btn
                    v-if="!isDeleting" plain x-small color="primary"
                    v-on:click.stop="downloadItem" title="download"
                    class="pa-0 ma-0"
                >
                    <v-icon small>mdi-download</v-icon>
                </v-btn>
                <v-btn 
                    v-if="isPassword && isFolder && !isSequence && !isDeleting" plain x-small color="primary"
                    v-on:click.stop="uploadToItem" title="upload files or folder to this remote location"
                >
                    <v-icon small>mdi-cloud-upload</v-icon>
                </v-btn>
                <v-btn
                    v-if="isPassword && !isDeleting" plain x-small color="primary"
                    v-on:click.stop="deleteItem"
                >
                    <v-icon small>mdi-delete</v-icon>
                </v-btn-->
            </div>
        </div>
        <div v-else
            @click="activateItem"
            style="cursor:pointer;clear:both"
        >
            <!--span v-if="isFolder">[{{ isOpen ? '-' : '+' }}]</span-->
            <v-icon v-if="isFolder && !isLoading" @click="toggle" small class="float-left pa-1">
                {{ isOpen ? "mdi-minus" : "mdi-plus" }}
            </v-icon>
            <v-progress-circular
                v-if="isFolder && isLoading" class="ma-2 float-left"
                :size="10" :width="2" indeterminate color="primary"
            ></v-progress-circular>

            <!--v-checkbox
                v-if="item.is_seq"
                v-model="item.selected_sequences"
                :value="item.path"
                dense
                color="blue"
                style="width:24px;float:left;"
                class="ma-0 pa-0"
                hide-details
                v-on:click.stop=""
                @change="selectDeselectSeqs"
            ></v-checkbox-->

            <!--v-checkbox
                v-if="!item.is_dir && !item.is_seq"
                v-model="item.selected_files"
                :value="item.path"
                dense
                color="blue"
                style="width:24px;float:left;"
                class="ma-0 pa-0"
                hide-details
                @change="selectDeselectItem"
            ></v-checkbox-->

            <template v-if="isFolder">
                <v-icon v-if="isSequence" small>
                    {{ isOpen ? 'mdi-image-multiple-outline' : 'mdi-image-multiple' }}
                </v-icon>
                <v-icon v-else small>
                    {{ isOpen ? 'mdi-folder-open' : 'mdi-folder' }}
                </v-icon>
            </template>
            <template v-else>
                <v-icon small class="ml-6">
                    mdi-panorama
                </v-icon>
            </template>
            <span class="mx-2">{{item.Name}}</span>
            <span v-if="!isFolder && !isSequence" class="caption grey--text">({{humanFileSize(item.Size)}}) - {{(item.LastModified)}}</span>
            <!--v-chip v-if="isDeleting" x-small color="red" class="ml-1">deleting</v-chip-->
            <v-btn v-if="isFolder && isLoaded" plain x-small color="primary" @click="reloadFolder">
                <v-icon small>mdi-reload</v-icon>
            </v-btn>
            <!--v-btn
                v-if="isSequence && simPreviewEnabled" plain x-small color="primary"
                v-on:click.stop="previewItem" title="preview"
                class="pa-0 ma-0"
            >
                <v-icon small>mdi-movie-play-outline</v-icon>
            </v-btn>
            <v-btn
                v-if="!isDeleting" plain x-small color="primary"
                v-on:click.stop="downloadItem" title="download"
                class="pa-0 ma-0"
            >
                <v-icon small>mdi-download</v-icon>
            </v-btn>
            <v-btn 
                v-if="isPassword && isFolder && !isSequence && !isDeleting" plain x-small color="primary"
                v-on:click.stop="uploadToItem" title="upload files or folder to this remote location"
            >
                <v-icon small>mdi-cloud-upload</v-icon>
            </v-btn>
            <v-btn
                v-if="isPassword && !isDeleting" plain x-small color="primary"
                v-on:click.stop="deleteItem"
            >
                <v-icon small>mdi-delete</v-icon>
            </v-btn-->
        </div>
        <div v-show="isOpen" v-if="isFolder" class="ml-5">
            <TreeItem
                class="item"
                v-for="(child, index) in item.children"
                :key="index"
                :item="child"
                :view="view"
                :selectedNode="selectedNode"
                @make-folder="$emit('make-folder', $event)"
                @add-item="$emit('add-item', $event)"
                @delete-item="$emit('delete-item', $event)"
                @preview-item="$emit('preview-item', $event)"
                @download-item="$emit('download-item', $event)"
                @upload-to-item="$emit('upload-to-item', $event)"
                @toggle-item="$emit('toggle-item', $event)"
                @reload-item="$emit('reload-item', $event)"
                @activate-item="$emit('activate-item', $event)"
                @load-more-items="$emit('load-more-items', $event)"
                @select-deselect-item="$emit('select-deselect-item', $event)"
                @select-deselect-seqs="$emit('select-deselect-seqs', $event)"
            ></TreeItem>
            <div v-if="!view">
                <v-btn v-if="loadMore && !isLoading" depressed x-small color="green" @click="loadMoreItems(item)">
                    Load More
                </v-btn>
                <v-progress-circular
                    v-if="loadMore && isLoading" class="mt-2 float-left"
                    :size="10" :width="2" indeterminate color="primary"
                ></v-progress-circular>
            </div>
            <!--li class="add" @click="$emit('add-item', item)">+</li-->
        </div>
    </div>
</template>

<script>
export default {
    name: "TreeItem",
    props: {
        item: Object,
        view: Boolean,
        selectedNode: Object || null
    },
    data: function() {
        return {
            selected_sequences: [],
            selected_files: [],
            sim_preview_extensions: [ "bgeo", "bgeo.sc"]
        };
    },
    computed: {
        isFolder: function() {
            return this.item.is_dir || this.item.is_seq;
        },
        isSequence: function() {
            return this.item.is_seq;
        },
        isOpen: function() {
            return this.item.open || false;
        },
        isLoaded: function() {
            return this.item.loaded || false;
        },
        isLoading: function() {
            return this.item.loading || false;
        },
        isDeleting: function() {
            return this.item.deleting || false;
        },
        loadMore: function() {
            return this.item.load_more || false;
        },
        isPassword: function() {
            if (this.$session.exists()) {      
                var current_user = this.$session.get("current_user");
                return current_user.ispassword ? true : false;
            }else{
                return false;
            }
        },
        simPreviewEnabled: function() {
            var sim_preview_supported = false;
            for (var i=0;i<this.sim_preview_extensions.length;i++){
                var extension = this.sim_preview_extensions[i];
                if (this.item.path.endsWith(extension)){
                    sim_preview_supported = true;
                    break;
                }
            }
            var sim_preview_enabled = JSON.parse(localStorage.getItem("sim_preview_enabled")) || false;

            return sim_preview_supported && sim_preview_enabled
        }
    },
    methods: {
        toggle: function() {
            if (this.isFolder) {
                //this.isOpen = !this.isOpen;
                this.$emit("toggle-item", this.item);
            }
        },
        makeFolder: function() {
            if (!this.isFolder) {
                this.$emit("make-folder", this.item);
                //this.$emit("toggle-item", this.item);
                //this.isOpen = true;
            }
        },
        reloadFolder: function() {
            this.$emit("reload-item", this.item);
        },
        previewItem: function(){
            this.$emit("preview-item", this.item);
        },
        downloadItem: function(){
            this.$emit("download-item", this.item);
        },
        uploadToItem: function(){
            this.$emit("upload-to-item", this.item);
        },
        deleteItem: function(){
            this.$emit("delete-item", this.item);
        },
        loadMoreItems: function(){
            this.$emit("load-more-items", this.item);
        },
        selectDeselectItem: function(){
            this.$emit("select-deselect-item", this.item);
        },
        selectDeselectSeqs: function(){
            this.$emit("select-deselect-seqs", this.item);
        },
        activateItem: function(){
            this.$emit("activate-item", this.item);
        },
        humanFileSize(bytes, si=false, dp=1) {
            const thresh = si ? 1000 : 1024;
            if (Math.abs(bytes) < thresh) {
                return bytes + ' B';
            }

            const units = si 
                ? ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] 
                : ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
                //: ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
            let u = -1;
            const r = 10**dp;

            do {
                bytes /= thresh;
                ++u;
            } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

            return bytes.toFixed(dp) + ' ' + units[u];
        },
        to_local_datetime(utc_datetime){
            let utc_dt_string = `${utc_datetime}Z`;
            let local_dt = new Date(utc_dt_string);
            let year = local_dt.getFullYear();
            let month = local_dt.getMonth() < 9 ? `0${(local_dt.getMonth()+1)}` : (local_dt.getMonth()+1);
            let date = local_dt.getDate() < 10 ? `0${local_dt.getDate()}` : local_dt.getDate();
            let hours = local_dt.getHours() < 10 ? `0${local_dt.getHours()}` : local_dt.getHours();
            let mins = local_dt.getMinutes() < 10 ? `0${local_dt.getMinutes()}` : local_dt.getMinutes();
            let secs = local_dt.getSeconds() < 10 ? `0${local_dt.getSeconds()}` : local_dt.getSeconds();
            let local_st_string = `${year}-${month}-${date} ${hours}:${mins}:${secs}`;
            return local_st_string;
        }
    }
}
</script>